import { Redirect } from 'react-router-dom';
import { ROUTES_URL } from 'src/constants/routes';

/**
 * Редирект: /begin_work/format больше не используется.
 * Следующий шаг после описания бизнеса — /leadstream (запуск сервиса).
 */
export default function FormatWrapper() {
    return <Redirect to={ROUTES_URL.LEADSTREAM} />;
}
